import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar/Sidebar";
import { Routes, Route, Outlet, useLocation } from "react-router-dom";
import { ReactComponent as Graduation } from "../../../Assets/Image/svg/graduation.svg";
import { FaRegUserCircle, FaCertificate } from "react-icons/fa";
import Breadcrumb from "../breadcrumb/Breadcrumb";

function StudentCourse({ menu }) {
    const location = useLocation();
    const [name, setName] = useState("");
    useEffect(() => {
        if (location.state?.title) setName(location.state?.title);
    }, [location]);

    return (
        <div className="grid grid-cols-5">
            <div>
                <Sidebar menu={menu} />
            </div>
            <main className="col-span-4">
                <div className="flex justify-between bg-white-dark py-[1.2rem] pr-[1.7rem] pl-[3.7rem] mb-[.7rem]">
                    <h2 className="text-light-prim1 text-[1.6rem]">{name}</h2>
                    <div className="flex items-center coursedashboard__side-title-icon">
                        <Graduation className="h-[2rem] ml-[3rem]" />
                        <FaRegUserCircle className="text-[1.5rem]" />
                    </div>
                </div>
                <div className=" pr-[1.7rem] pl-[5rem]">
                    <Breadcrumb className="mb-[5rem]" />
                    <Outlet />
                </div>
            </main>
        </div>
    );
}

export default StudentCourse;
